/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.animationModule')

/**
 * This directive implements a DOM container that slides to the height needed to display an active child element
 * and then fades in that element; or closes by fading out the last-active element and then sliding to height 0.
 *
 * The active content is dynamically controlled by the 'active-class-name' attribute, whose value as a class selector
 * must either match a single contained element, or be empty to signify the container should be closed.
 *
 * If the 'active-class-name' attribute value contains '-mobile', the container will slide to/from the entire
 * height of the browser window to fit the device's display.
 *
 * Example:
 *     <bulb-slide-and-fade active-class-name="{{headerCtrl.headerType ? 'bulb-header-' + headerCtrl.headerType : ''}}"
 *                           on-animations-done="headerCtrl.openCloseDone()">
 *      <div class="bulb-header-general">
 *          ...
 *      </div>
 *      <div class="bulb-header-search">
 *          ...
 *      </div>
 *      <div class="bulb-header-general-mobile">
 *          ...
 *      </div>
 *    </bulb-slide-and-fade>
 *
 * FUTURE: This directive isn't very generic, and could be moved into header-directive.js
 * FUTURE: If we end up using Foundation for Apps we might want to look at their slide-in panel component
 */
.directive('bulbSlideAndFade', ['$animate','$log','$q','$window', bulbSlideAndFade]);

function bulbSlideAndFade($animate, $log, $q, $window) {
  return {
    restrict: 'E',
    scope: {
      activeClassName: '@',
      onAnimationsDone: '&'
    },
    link: function(scope, element, attrs) {

      /**
       * As of AngularJS 1.4, $animate.cancel doesn't reject the animation promise(!), meaning that
       * additional sequenced animations in .then() or .done() functions will run regardless of whether
       * the animation has been canceled.
       *
       * Instead of keeping track of running/canceled animations, we increment an "animation cycle" counter
       * each time the activeClassName changes.  This counter value is captured and passed as an animationCycle
       * parameter to the slideAndFade function, which compares it with this closure value before starting
       * each subsequent animation or invoking scope.onAnimationsDone().
       */
      var currentAnimationCycle = 0;

      /**
       * Executes the animation sequences to slide the container height and fade in/out content.
       *
       * @param newActiveClassName  String  class name that uniquely identifies a child Element
       * @param oldActiveClassName  String  class name that uniquely identifies a child Element
       * @param animationCycle compared with (closure variable) currentAnimationCycle before starting
       *        each animation or invoking scope.onAnimationsDone()
       */
      function slideAndFade(newActiveClassName, oldActiveClassName, animationCycle) {
        $log.debug('bulbSlideAndFade from ' + oldActiveClassName + ' to ' + newActiveClassName);

        var newContent;
        var isNewContentMobile = false;
        if (newActiveClassName) {
          isNewContentMobile = newActiveClassName.indexOf('-mobile') > -1;
          newContent = element.find('.' + newActiveClassName);
          if (!newContent.length) {
            $log.error('[bulbSlideAndFade] no element with class .' + newActiveClassName);
            return;
          }
        }

        // Fade out any old content
        var fadeOutPromise = null;
        if (oldActiveClassName) {
          var isOldContentMobile = oldActiveClassName.indexOf('-mobile') > -1;
          var oldContent = element.find('.' + oldActiveClassName);
          if (oldContent.length) {
            oldContent.removeClass('bulb-active-content');
            $log.debug('fadeOut ' + oldActiveClassName);
            fadeOutPromise = $animate.removeClass(oldContent, 'bulb-fade-in');
          } else {
            $log.warn('[bulbSlideAndFade] no element with class .' + oldActiveClassName);
          }
        }

        // Slide container's height to the new content's height, or to 0 if no new content
        $q.when(fadeOutPromise, function() {
          if (animationCycle === currentAnimationCycle) {
            var windowHeight = $window.innerHeight;

            if (isOldContentMobile) {
              element.css({
                minHeight: '',
                height: windowHeight
              });
              // Show page and footer content
              jQuery('.bulb-content, .bulb-footer').css({
                display: ''
              });
              // Position the color bar so it moves with the content
              jQuery('.bulb-color-bar').css({
                position: '',
                bottom: ''
              });
            }

            if (newActiveClassName) {
              newContent.addClass('bulb-active-content');

              // Slide container's height to match the height of the new content
              $log.debug('slideIn ' + newActiveClassName);
              if (isNewContentMobile) {
                newContent.css({
                  height: windowHeight
                });
              }
              element.removeClass('bulb-slide');
              $animate.addClass(element, 'bulb-slide').then(function () {
                if (animationCycle === currentAnimationCycle) {
                  if (isNewContentMobile) {
                    element.css({
                      minHeight: windowHeight,
                      height: 'inherit'
                    });
                    // Hide page and footer content
                    jQuery('.bulb-content, .bulb-footer').css({
                      display: 'none'
                    });
                    // Position the color bar so it stays at the bottom
                    jQuery('.bulb-color-bar').css({
                      position: 'fixed',
                      bottom: '0'
                    });
                  }

                  // Fade in the new active content
                  $log.debug('fadeIn ' + newActiveClassName);
                  $animate.addClass(newContent, 'bulb-fade-in').done(function () {
                    if (animationCycle === currentAnimationCycle) {
                      scope.onAnimationsDone();
                    }
                  });
                }
              });
            } else {
              // Close the container by sliding its height to 0
              $log.debug('slideOut (to 0)');
              $animate.removeClass(element, 'bulb-slide').done(function() {
                element.height(0);  // TODO ISSUE : This is a workaround to fix the issue where
                // sometimes the menu doesn't close after creating a new page.  The problem seems
                // related to the animation being cancelled before it executes.  Setting the height
                // explicitly to 0 is a fall back, in case the animation fails to set it to 0.
                if (animationCycle === currentAnimationCycle) {
                  scope.onAnimationsDone();
                }
              });
            }
          }
        });
      }

      var oldActiveClassName = '';
      attrs.$observe('activeClassName', function(newActiveClassName) {
        if (newActiveClassName !== oldActiveClassName) {
          ++currentAnimationCycle;
          slideAndFade(newActiveClassName, oldActiveClassName, currentAnimationCycle);
          oldActiveClassName = newActiveClassName;
        }
      });
    }
  };
}
